export const TYP_CONFIG: { [key: string]: string | number } = {
  baseFontSize: '15px',
  baseLineHeight: '24px',
  scaleFactor: 1.3,
}

export const BREAKPOINTS = [`576`, `992`]

export const SPACE: { [key: string]: { [key: string]: any } } = {
  inset: {
    xs: `padding: 8px`,
    s: `padding: 16px`,
    m: `padding: 24px`,
    l: `padding: 32px`,
    squish: {
      xs: `padding: 4px 8px`,
      s: `padding: 8px 16px`,
      m: `padding: 16px 24px`,
      l: `padding: 24px 32px`,
    },
    stretch: {
      s: `padding: 24px 16px`,
      m: `padding: 32px 24px`,
      l: `padding: 48px 32px`,
    },
  },
  stack: {
    xs: `margin-bottom: 8px`,
    s: `margin-bottom: 16px`,
    m: `margin-bottom: 24px`,
    l: `margin-bottom: 32px`,
    xl: `margin-bottom: 48px`,
    xxl: `margin-bottom: 72px`,
  },
  inline: {
    xs: `margin-left: 8px`,
    s: `margin-left: 16px`,
    m: `margin-left: 24px`,
    l: `margin-left: 32px`,
    xl: `margin-left: 48px`,
    xxl: `margin-left: 72px`,
  },
}



// WEBPACK FOOTER //
// ./src/styles/constants.ts